<template>
  <div></div>
</template>

<script setup lang="ts">
  import { useHead } from '@unhead/vue'
  import { useSchemaOrg, defineWebPage } from '@unhead/schema-org/vue'

  const props = defineProps<{
    feature: object
  }>()

  useHead({
    title: props.feature.meta_title,
    meta: [
      {
        name: 'description',
        content: props.feature.meta_description,
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: `/${props.feature.slug}`,
      },
    ],
  })

  useSchemaOrg([
    defineWebPage({
      '@type': 'WebPage',
    }),
  ])
</script>
